
export const getOrderTotal = state => state.orderTotal || {}
export const getLatestOrderTotal = state => state.orderTotal.latest || {}
export const getLatestOrderNumber = state => state.orderTotal.latestOrderNumber || ''
